import { CourseData } from '@data/course/courseData';
import React, { useState } from 'react';
import CourseInfoBox from '../CourseInfoBox';
import CourseDataEditor from './CourseDataEditor';
import CourseDataViewer from './CourseDataViewer';

export type FormCourseDataOnly = Omit<
  CourseData,
  | 'frozen'
  | 'curriculumFiles'
  | 'courseApprovalRef'
  | 'curriculumApprovalRef'
  | 'archived'
  | 'instructorIds'
>;

interface CourseDataInfoBoxProps {
  courseFrozen: boolean;
  initialData: FormCourseDataOnly;
  onChange: (values: FormCourseDataOnly) => Promise<void>;
  updateValidity: (valid: boolean) => void;
}

const CourseDataInfoBox: React.FC<CourseDataInfoBoxProps> = ({
  courseFrozen,
  initialData,
  onChange,
  updateValidity,
}) => {
  const [error, setError] = useState('');

  return (
    <CourseInfoBox
      className='col-span-3'
      header='Course Info'
      description={
        courseFrozen ? 'View submitted course info below' : 'Edit course information below.'
      }
    >
      <div className='ml-8 mb-6'>
        {courseFrozen ? (
          <CourseDataViewer data={initialData} />
        ) : (
          <CourseDataEditor
            initialData={initialData}
            onChange={(values, isValid) => {
              onChange(values)
                .then(() => setError(''))
                .catch((e: Error) => setError(e.message));
              updateValidity(isValid);
            }}
          />
        )}
      </div>
      <p className='text-red-600'>{error}</p>
    </CourseInfoBox>
  );
};

export default CourseDataInfoBox;
